import React from "react";
import { Link } from "react-router-dom";
import LoadJquery from "../helper/LoadJquery";
import AboutUs from "../components/Financial_Consulting/AboutUs4";
import Financial from "../components/Financial_Consulting/Financial";
import FinancialProcessUI from "../components/Financial_Consulting/FinancialProcess";
import FinancialInsights from "../components/Financial_Consulting/Insights";
import FinancialFaq from "../components/Financial_Consulting/FinancialFaq";
import VisitorTracker from '../components/VisitorTracker';
import useContactForm from '../hooks/useContactForm';

const Financial_Demo = () => {
  // Validation, submit guarding, per-field errors and form analytics all
  // live in the shared hook. The source page name is what lets the admin
  // console attribute this lead to the right page.
  const {
    formData, errors, isLoading, handleSubmit, handleInputChange, fieldProps,
  } = useContactForm("financial-planning");

  // Renders the message under a field, and nothing when it is valid.
  const Err = ({ name }) =>
    errors[name] ? (
      <p className="form-field-error" id={`${name}-error`} role="alert">
        <i className="fa-solid fa-circle-exclamation" aria-hidden="true" />{" "}
        {errors[name]}
      </p>
    ) : null;
  return (
    
    <div>
      <LoadJquery />
      <VisitorTracker page="financial-planning" />
      {/* <!-- tpm-header-area start --> */}
      {/* <!-- tpm-header-area start --> */}

      {/* <!-- tpm-header-area end --> */}

      {/* <!-- Start banner area  --> */}
      <div className="banner-area banner-style-two bg_image tmp-section-gapTop">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-5 order-xl-1 order-lg-1 order-md-2 order-sm-2 order-2">
              <div className="banner-inner">
                <div
                  className="sub-title"
                  style={{ display: "block" }}
                  data-sal-delay="150"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  Financial Consulting Agency
                </div>
                <h2 className="title split-collab">
                  Prosper in this <br /> volatile market <br /> founding.
                </h2>
                <p
                  className="description"
                  data-sal-delay="350"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  We help small startups grow from idea to millions of users. we
                  can also automate your marketing and customer service.
                </p>
                <div
                  className="banner-bottom"
                  style={{ gap: "30px" }}
                  data-sal-delay="450"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <Link to="/contact" className="tmp-btn btn-secondary">
                    Get Started Now
                  </Link>
                  {/* <!-- video icon --> */}
                  {/* <div
                    className="vedio-icone"
                    data-tmp-cursor="lg"
                    data-tmp-cursor-text="Play Video"
                  >
                    <Link className="video-play-button play-video" to="#">
                      <span
                        style={{ borderLeftColor: "var(--color-secondary)" }}
                      ></span>
                      <p className="text" style={{ color: "black;" }}>
                        Intro Video
                      </p>
                    </Link>
                    <div className="video-overlay">
                      <Link className="video-overlay-close">×</Link>
                    </div>
                  </div> */}
                  {/* <!-- video icon --> */}
                </div>
              </div>
            </div>
            <div className="col-lg-5 offset-lg-2  order-xl-2 order-lg-2 order-md-1 order-sm-1 order-1">
              <div className="banner-two-thumbnail">
                <div className="thumbnail">
                  <img
                    src="assets/images/banner/banner-two-2.png"
                    alt="Business_Corporate"
                    data-sal-delay="250"
                    data-sal="slide-left"
                    data-sal-duration="800"
                  />
                  {/*<div className="product-share product-share-style-two">
                    <div className="rating">
                      <div className="number">4.8</div>
                      <div className="stars-group">
                        <div className="star">
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>
                          <i className="fa-solid fa-star"></i>

                          <i className="fa-solid fa-star-half-stroke"></i>
                        </div>
                      </div>
                    </div>
                    <div className="profile-share">
                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img src="assets/images/about/4.png" alt="education" />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img src="assets/images/about/5.png" alt="education" />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img src="assets/images/about/6.png" alt="education" />
                      </Link>

                      <Link
                        to="#"
                        className="avatar"
                        data-tooltip="Mark JOrdan"
                        tabIndex="0"
                      >
                        <img src="assets/images/about/7.png" alt="education" />
                      </Link>
                    </div>
                  </div>*/}

                  <div className="banner-tag">
                    <div className="inner">
                      <div className="icon bg-color-secondary radius-circle mr--20">
                        <i className="fa-regular fa-check"></i>
                      </div>
                      <div className="content">
                        <h3 className="title">
                          Save up to 50% in
                          <br />
                          Yearly plan.
                        </h3>

                        <Link className="btn-learn-more" to="#">
                          Learn More
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-circle">
          <img src="assets/images/banner/banner-circle.png" alt="banner" />
        </div>

        <div className="bg-dolour">
          <img src="assets/images/banner/banner-dolour.png" alt="banner" />
        </div>

        <div className="bg-blue-circle">
          <img src="assets/images/banner/blue-circle.png" alt="banner" />
        </div>

        <div className="bg-curly-lines">
          <img src="assets/images/banner/curly-lines.png" alt="banner" />
        </div>
      </div>
      {/* <!-- End banner area  --> */}

      {/* <!-- Start Service Area  --> */}
      <div className="service-area tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head">
                <div className="section-sub-title color-secondary  center-title">
                  <span>OUR SERVICES</span>
                </div>
                <h2 className="section-title split-collab">
                  Our provided services
                </h2>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">
                  <img
                    src="assets/images/services/service-icon-1.png"
                    alt="corporate Business Services"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Business Stratagy</h2>
                  <p className="description">
                    We help businesses create effective growth strategies, optimize operations, and make informed financial decisions to achieve long-term success.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">
                  <img
                    src="assets/images/services/service-icon-2.png"
                    alt="corporate Business Services"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Investment Advisory</h2>
                  <p className="description">
                    Our experts provide personalized investment guidance, portfolio management, and risk analysis to help you maximize returns while minimizing risks.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">
                  <img
                    src="assets/images/services/service-icon-3.png"
                    alt="corporate Business Services"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Data Analysis</h2>
                  <p className="description">
                    We turn complex financial data into actionable insights, enabling smarter decision-making, performance tracking, and future growth planning.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="450"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">
                  <img
                    src="assets/images/services/service-icon-4.png"
                    alt="corporate Business Services"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Saving & Investments</h2>
                  <p className="description">
                    We design tailored saving plans and investment opportunities to secure your financial future and build wealth with confidence.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="550"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">
                  <img
                    src="assets/images/services/service-icon-5.png"
                    alt="corporate Business Services"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Website Design</h2>
                  <p className="description">
                    We create modern, user-friendly financial websites that enhance your brand presence, improve customer engagement, and build trust.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="col-lg-4 col-md-6 col-sm-6 col-12"
              data-sal-delay="650"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="service-inner financial-service-inner">
                <div className="icon">
                  <img
                    src="assets/images/services/service-icon-6.png"
                    alt="corporate Business Services"
                  />
                </div>
                <div className="content">
                  <h2 className="title">Mutual Funds</h2>
                  <p className="description">
                    Our team offers guidance on choosing the right mutual funds, balancing risk and reward, and building a diversified investment portfolio.
                  </p>
                  <div className="three--dot">
                    <div className="dot dot-one"></div>
                    <div className="dot dot-two"></div>
                    <div className="dot dot-two"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Service Area  --> */}

      {/* About Component Started */}
      <AboutUs/>
      <Financial/>
      < FinancialProcessUI/>
      <FinancialInsights/>
      <FinancialFaq/>

      {/* <!-- Start About Area  --> */}
      {/* <div className="about-area about-style-two tmp-section-gapBottom">
        <div className="container">
          <div className="row align-items-center">
            <div
              className="col-lg-6"
              data-sal-delay="150"
              data-sal="slide-right"
              data-sal-duration="800"
            >
              <div className="about-thumbnails about-style-two">
                <img
                  src="assets/images/about/about-style-2.png"
                  alt="Business Consulting about"
                />

                <div className="dots animated tada">
                  <img
                    className="tada"
                    src="assets/images/about/dots.png"
                    alt="Business Consulting dots"
                  />
                </div>
                <div className="scater">
                  <img
                    src="assets/images/about/scater.png"
                    alt="Business Consulting scater"
                  />
                </div>
                <div className="tmpk__circle v__1">
                  <svg viewBox="0 0 500 500">
                    <defs>
                      <path
                        id="circle"
                        d="M250,250 m-200,0 a200,200 0 1,1 400,0 a200,200 0 1,1 -400,0"
                      />
                    </defs>
                    <text>
                      <textPath xlinkHref="#circle">
                        25+ Years Of Working Experience * Experience *
                      </textPath>
                    </text>
                  </svg>

                  <div className="tmpk__circle--icon">
                    <i className="fa-light fa-arrow-right"></i>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="inner">
                <div className="section-head section-head-one-side text-align-left">
                  <div className="section-sub-title color-secondary">
                    <span className="subtitle">About Us</span>
                  </div>
                  <h2 className="title split-collab">
                    Find out more about our <br /> business consulting
                  </h2>
                </div>

                <p className="description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur eget ornare quam. Sed sit amet sem sollicitudin,
                  condimentum diam sed, consequat tellus. Quisque ac odio eget
                  ligula gravida efficitur. Nunc facilisis sagittis magna, non
                  venenatis mauris luctus quis. Nulla sapien purus feugiat vel
                  dictum sit amet.
                </p>

                <div className="feature-counter">
                  <div className="tmp-feature-wrapper">
                    <h3 className="title">Grow Your Business</h3>
                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon"></i>
                      </div>
                      <div className="feature-content">
                        <h6 className="title">Flexible Classes</h6>
                      </div>
                    </div>

                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon"></i>
                      </div>
                      <div className="feature-content">
                        <h6 className="title">Innovative Ideas</h6>
                      </div>
                    </div>

                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon"></i>
                      </div>
                      <div className="feature-content">
                        <h6 className="title">Financial Consulting</h6>
                      </div>
                    </div>

                    <div className="tmp-feature">
                      <div className="icon bg-color-secondary-alt radius-circle">
                        <i className="fa-regular fa-check small-icon"></i>
                      </div>
                      <div className="feature-content">
                        <h6 className="title">Risk Management</h6>
                      </div>
                    </div>
                  </div>
                  <div className="counter-wrapper counter-style-one">
                    <div className="counter-inner">
                      <h2 className="title">
                        <span className="counter">1538</span>+
                      </h2>
                      <p className="description">
                        Projects completed <br /> in last 5 years
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End About Area  --> */}

      {/* <!-- Start Counter area  --> */}
      {/* <div className="history-area history-style-one counter-history-bg-image bg_image tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head color-white style-two">
                <div className="section-sub-title color-white  center-title">
                  <span>OUR History</span>
                </div>
                <h2 className="title color-white split-collab">
                  Bizper is partnered with 10k+ fastest <br />
                  growing companies from 2008
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-5">
            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="history-inner style-one">
                <div className="custom-icon">
                  <img src="assets/images/counter/01.png" alt="" />
                </div>
                <div className="counter-wrapper">
                  <div className="single-counter">
                    <h2 className="number">
                      <span className="counter">89</span>
                      <span>%</span>
                    </h2>
                    <h3 className="title">SATISFAID CLIENTS</h3>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="history-inner style-one">
                <div className="custom-icon">
                  <img src="assets/images/counter/02.png" alt="" />
                </div>
                <div className="counter-wrapper">
                  <div className="single-counter">
                    <h2 className="number">
                      <span className="counter">55</span>
                      <span>+</span>
                    </h2>
                    <h3 className="title">COUNTRIES WORLDWIDE</h3>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="history-inner style-one">
                <div className="custom-icon">
                  <img src="assets/images/counter/03.png" alt="" />
                </div>
                <div className="counter-wrapper">
                  <div className="single-counter">
                    <h2 className="number">
                      <span className="counter">789</span>
                      <span>K</span>
                    </h2>
                    <h3 className="title">INTERNATIONAL AWARDS</h3>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-3 col-md-6 col-sm-6 col-12"
              data-sal-delay="450"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="history-inner style-one">
                <div className="custom-icon">
                  <img src="assets/images/counter/04.png" alt="" />
                </div>
                <div className="counter-wrapper">
                  <div className="single-counter">
                    <h2 className="number">
                      <span className="counter">102</span>
                      <span>m</span>
                    </h2>
                    <h3 className="title">EXPERT STAFFS</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End Counter area  --> */}

      {/* <!-- Start Portfolio area  --> */}
      {/* <div className="portfolio-area portfolio-style-two tmp-section-gap">
        <div className="container">
          <div className="row mb--30">
            <div className="col-lg-5 col-md-6">
              <div className="inner">
                <div className="section-head section-head-one-side text-align-left">
                  <div className="section-sub-title color-secondary">
                    <span className="subtitle">OUR PORTFOLIO</span>
                  </div>
                  <h2 className="title split-collab">
                    Let's check our best <br /> recent work{" "}
                  </h2>
                </div>

                <p className="description">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur eget ornare quam. Sed sit amet sem sollicitudin,
                  condimentum diam sed, consequat tellus. Quisque ac odio eget
                  ligula gravida efficitur. Nunc facilisis sagittis magna, non
                  venenatis mauris luctus quis.
                </p>

                <Link
                  to="/project"
                  className="tmp-btn btn-with-icon btn-secondary"
                >
                  Our All Works<i className="fa-light fa-arrow-right"></i>
                </Link>
              </div>
            </div>
            <div
              className="col-lg-7 col-md-6 mt_md--80 mt_sm--50 "
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div
                className="portfolio-inner"
                data-tmp-cursor="lg"
                data-tmp-cursor-text="View Details"
              >
                <Link to="/project/details" className="thumbnail">
                  <img
                    src="assets/images/portfolio/portfolio-two-1.png"
                    alt="corporate business"
                  />
                </Link>
                <div className="portfolio-tag">
                  <div className="content">
                    <Link to="/project/details">
                      <h3 className="name">Janet Phillips</h3>
                    </Link>
                    <div className="designation">Software Developer</div>
                  </div>
                  <Link
                    to="/project/details"
                    className="icon angle-roted border-none bg-color-white"
                  >
                    <i className="fa-solid fa-arrow-right"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div
              className="col-lg-4 col-md-6"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div
                className="portfolio-inner"
                data-tmp-cursor="lg"
                data-tmp-cursor-text="View Details"
              >
                <Link to="/project/details" className="thumbnail">
                  <img
                    src="assets/images/portfolio/portfolio-two-2.png"
                    alt="corporate business"
                  />
                </Link>
                <div className="portfolio-tag portfolio-md-tag">
                  <div className="content">
                    <Link to="/project/details">
                      <h3 className="name">Doris Sharp</h3>
                    </Link>
                    <div className="designation">Chief Architect</div>
                  </div>
                  <Link
                    to="/project/details"
                    className="icon icon--30 radius-circle border-none bg-color-white"
                  >
                    <i className="fa-solid fa-arrow-right transform-rotate-318"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div
              className="col-lg-4 col-md-6"
              data-sal-delay="450"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div
                className="portfolio-inner"
                data-tmp-cursor="lg"
                data-tmp-cursor-text="View Details"
              >
                <Link to="/project/details" className="thumbnail">
                  <img
                    src="assets/images/portfolio/portfolio-two-3.png"
                    alt="corporate business"
                  />
                </Link>
                <div className="portfolio-tag portfolio-md-tag">
                  <div className="content">
                    <Link to="/project/details">
                      <h3 className="name">Sharon Willis</h3>
                    </Link>
                    <div className="designation">Software Engineer</div>
                  </div>
                  <Link
                    to="/project/details"
                    className="icon icon--30 radius-circle border-none bg-color-white"
                  >
                    <i className="fa-solid fa-arrow-right transform-rotate-318"></i>
                  </Link>
                </div>
              </div>
            </div>

            <div
              className="col-lg-4 col-md-6"
              data-sal-delay="550"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div
                className="portfolio-inner"
                data-tmp-cursor="lg"
                data-tmp-cursor-text="View Details"
              >
                <Link to="/project/details" className="thumbnail">
                  <img
                    src="assets/images/portfolio/portfolio-two-4.png"
                    alt="corporate business"
                  />
                </Link>
                <div className="portfolio-tag portfolio-md-tag">
                  <div className="content">
                    <Link to="/project/details">
                      <h3 className="name">Gina Larsen</h3>
                    </Link>
                    <div className="designation">Product Manager</div>
                  </div>
                  <Link
                    to="/project/details"
                    className="icon icon--30 radius-circle border-none bg-color-white"
                  >
                    <i className="fa-solid fa-arrow-right transform-rotate-318"></i>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- Start Portfolio area  --> */}

      {/* <!-- Start pricing area  --> */}
      {/* <div className="pricing-area pricing-style-one tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head pb-40">
                <div className="section-sub-title color-secondary  center-title">
                  <span>BEST PRICING</span>
                </div>
                <h2 className="section-title split-collab">
                  Flexible plans for small to fast- <br />
                  growing business
                </h2>
              </div>
            </div>
          </div>

          <div className="row g-5">
            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="pricing-table pricing-style-one">
                <div className="pricing-header">
                  <div className="pricing-header-inner">
                    <h3 className="title">Basic Plan</h3>
                    <div className="price-wrap">
                      <div className="monthly-pricing">
                        <div className="amount">
                          <span className="dolour">$</span>29.
                          <span className="zero">00</span>
                        </div>
                        <span className="duration">Per Monthly</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pricing-body">
                  <ul className="plan-offer-list">
                    <li>
                      <i className="fa-light fa-check"></i>Business Consulting
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>24/7 Customer Support
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>Business Planning
                    </li>

                    <li className="off">
                      <i className="fa-sharp fa-light fa-xmark"></i>Digital
                      Business Solution
                    </li>
                    <li className="off">
                      <i className="fa-sharp fa-light fa-xmark"></i>Human
                      Research
                    </li>
                  </ul>
                </div>
                <div className="pricing-bottom">
                  <div className="pricing-btn">
                    <Link to="#" className="tmp-btn">
                      Purchase Plan
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="pricing-table pricing-style-one">
                <div className="pricing-header">
                  <div className="pricing-header-inner">
                    <h3 className="title">Premium Plan</h3>
                    <div className="price-wrap">
                      <div className="monthly-pricing">
                        <div className="amount">
                          <span className="dolour">$</span>59.
                          <span className="zero">00</span>
                        </div>
                        <span className="duration">Per Monthly</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pricing-body">
                  <ul className="plan-offer-list">
                    <li>
                      <i className="fa-light fa-check"></i>Business Consulting
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>24/7 Customer Support
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>Business Planning
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>Digital Business
                      Solution
                    </li>
                    <li className="off">
                      <i className="fa-sharp fa-light fa-xmark"></i>Human
                      Research
                    </li>
                  </ul>
                </div>
                <div className="pricing-bottom">
                  <div className="pricing-btn">
                    <Link to="#" className="tmp-btn">
                      Purchase Plan
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div
              className="col-lg-4 col-md-6 col-sm-12 col-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="pricing-table pricing-style-one">
                <div className="pricing-header">
                  <div className="pricing-header-inner">
                    <h3 className="title">Advanced Plan</h3>
                    <div className="price-wrap">
                      <div className="monthly-pricing">
                        <div className="amount">
                          <span className="dolour">$</span>89.
                          <span className="zero">00</span>
                        </div>
                        <span className="duration">Per Monthly</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pricing-body">
                  <ul className="plan-offer-list">
                    <li>
                      <i className="fa-light fa-check"></i>Business Consulting
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>24/7 Customer Support
                    </li>

                    <li>
                      <i className="fa-light fa-check"></i>Business Planning
                    </li>
                    <li>
                      <i className="fa-light fa-check"></i>Digital Business
                      Solution
                    </li>
                    <li>
                      <i className="fa-light fa-check"></i>Human Research
                    </li>
                  </ul>
                </div>
                <div className="pricing-bottom">
                  <div className="pricing-btn">
                    <Link to="#" className="tmp-btn">
                      Purchase Plan
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End pricing area  --> */}

      {/* <!-- Start Work Area  --> */}
      <div className="work-area work-style-one tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="work-top-inner">
              <div className="section-head pb-0 section-head-one-side text-align-left">
                <div className="section-sub-title color-white ">
                  <span className="subtitle">WHY CHOOSE US</span>
                </div>
                <h2 className="title color-white split-collab">
                  We working for you to build <br /> your business fast
                </h2>
              </div>

              <div
                className="single-work-top"
                data-sal-delay="250"
                data-sal="slide-up"
                data-sal-duration="800"
              >
                <h2 className="title">4M +</h2>
                <div className="sub-title">Business Using Stripe</div>
              </div>

              <div className="scater-line">
                <img src="assets/images/work/shape.png" alt="" />
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div
              className="col-lg-6 col-md-6"
              data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="inner">
                <Link to="#">
                  <div className="thumbnail">
                    <img
                      className="large"
                      src="assets/images/work/work-1.jpg"
                      alt="Business Consulting"
                    />
                  </div>
                </Link>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-6"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-work style-one mt--35">
                <Link to="#">
                  <div className="work-inner">
                    <div className="thumbnail">
                      <img
                        src="assets/images/work/consultation.png"
                        alt="Business Consulting"
                      />
                    </div>
                    <h3 className="title">Business Consulting</h3>
                    <p className="description">
                     We help businesses of all sizes unlock growth opportunities, improve efficiency, and overcome challenges. Our consulting services focus on strategy, operations, and financial planning to ensure sustainable success.
                    </p>
                  </div>
                </Link>
              </div>
            </div>
            <div
              className="col-lg-3 col-md-12"
              data-sal-delay="350"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="single-work style-one">
                <Link to="#" className="cart-box cart-box-1">
                  <div className="work-inner">
                    <div className="thumbnail">
                      <img
                        src="assets/images/work/consultation.png"
                        alt="Business Consulting"
                      />
                    </div>
                    <h3 className="title">Strategic Planning</h3>
                  </div>
                </Link>
              </div>
              <div className="single-work style-one mt--30">
                <Link to="#">
                  <div className="work-inner">
                    <div className="thumbnail">
                      <img
                        src="assets/images/work/consultation.png"
                        alt="Business Consulting"
                      />
                    </div>
                    <h3 className="title">IT Management</h3>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- End Work Area  --> */}

      {/* <!-- Start testimonial Area  --> */}
      {/* <div className="testimonial-area testimonial-style-two tmp-section-gapTop">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="section-head pb-40">
                <div className="section-sub-title color-secondary center-title">
                  <span>Client’s Testimonials</span>
                </div>
                <h2 className="section-title split-collab">
                  What clients have to say
                </h2>
              </div>
            </div>
          </div>
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="single-testimonial">
                <div className="testimonial-header">
                  <div className="header-inner">
                    <div className="content">
                      <div className="content-left">
                        <div className="thumbnail">
                          <img
                            src="assets/images/testimonial/img-sm-1.png"
                            alt="Business Consulting testimonial"
                          />
                        </div>
                      </div>
                      <div className="content-right">
                        <div className="name">Esther Howard</div>
                        <div className="designation">Web Developer</div>
                      </div>
                    </div>
                    <div className="icon">
                      <i className="fa-sharp fa-regular fa-quote-right"></i>
                    </div>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p className="description">
                    It’s incredible. it’s really wonderful. bcom has completely
                    surpassed our expect. Urna porttitor rhoncus dolor purus non
                    enim praesent at the facilisis lectus. Adipiscing tristique
                    risus feugiat fermentum.It’s incredible. it’s really
                    wonderful. bcom has completely surpassed our expect.
                  </p>
                  <div className="rating rating-style-two">
                    <div className="title">Rating : </div>
                    <div className="stars-group">
                      <div className="star">
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star-half-stroke"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="single-testimonial">
                <div className="testimonial-header">
                  <div className="header-inner">
                    <div className="content">
                      <div className="content-left">
                        <div className="thumbnail">
                          <img
                            src="assets/images/testimonial/img-sm-1.png"
                            alt="Business Consulting testimonial"
                          />
                        </div>
                      </div>
                      <div className="content-right">
                        <div className="name">Esther Howard</div>
                        <div className="designation">Web Developer</div>
                      </div>
                    </div>
                    <div className="icon">
                      <i className="fa-sharp fa-regular fa-quote-right"></i>
                    </div>
                  </div>
                </div>
                <div className="testimonial-body">
                  <p className="description">
                    It’s incredible. it’s really wonderful. bcom has completely
                    surpassed our expect. Urna porttitor rhoncus dolor purus non
                    enim praesent at the facilisis lectus. Adipiscing tristique
                    risus feugiat fermentum.It’s incredible. it’s really
                    wonderful. bcom has completely surpassed our expect.
                  </p>
                  <div className="rating rating-style-two">
                    <div className="title">Rating :</div>
                    <div className="stars-group">
                      <div className="star">
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star"></i>
                        <i className="fa-solid fa-star-half-stroke"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End testimonial Area  --> */}

      {/* <!-- Start Blog Area   --> */}
      {/* <div className="blog-area tmp-section-gap">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-3 col-md-4 col-sm-12 col-12">
              <div className="inner">
                <div className="section-head section-head-one-side text-align-left">
                  <div className="section-sub-title color-secondary">
                    <span className="subtitle">LATEST BLOG</span>
                  </div>
                  <h2 className="title split-collab">
                    Latest news & <br /> articles from <br /> the blog
                  </h2>
                </div>

                <p
                  className="description"
                  data-sal-delay="250"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                  Curabitur eget ornare quam. Sed sit amet sem sollicitudin.
                </p>

                <div
                  className="single-blog blog-style-two"
                  data-sal-delay="350"
                  data-sal="slide-up"
                  data-sal-duration="800"
                >
                  <div className="blog-inner">
                    <div className="thumbnail">
                      <Link to="/blog/details">
                        <img
                          src="assets/images/blog/blog-1.png"
                          alt="Business Consulting Blog"
                        />
                      </Link>
                      <div className="pmt-blog-meta">
                        <ul className="all-meta">
                          <li className="date bg--secondary">
                            <span>20</span>
                          </li>
                          <li className="month">
                            <span>JAN</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="blog-content">
                      <div className="blog-head">
                        <span className="name">Sultan Ahmed</span>
                        <span className="designation">Consulting</span>
                      </div>
                      <div className="blog-body">
                        <Link to="/blog/details"ssName="title-area">
                          <h4 className="title sm-title">
                            Consulted admitting wooded is power acuteness.
                          </h4>
                        </Link>
                      </div>
                      <Link className="btn-read-more" to="/blog/details">
                        <span className="read-more-text">Read More</span>
                        <span className="read-more-icon">
                          <i className="fa-solid fa-arrow-right"></i>
                        </span>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-4 col-sm-12 col-12">
              <div className="single-blog blog-style-two">
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src="assets/images/blog/blog-2.png"
                        alt="Business Consulting Blog"
                      />
                    </Link>
                    <div className="pmt-blog-meta">
                      <ul className="all-meta">
                        <li className="date bg--secondary">
                          <span>20</span>
                        </li>
                        <li className="month">
                          <span>JAN</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">Sultan Ahmed</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title lg-title">
                          Grow your siness strategy with business consulting.
                        </h4>
                      </Link>
                      <p className="description">
                        One order all scale sense her gay style wrote. Incommode
                        our not one ourselves residence. Shall there whose those
                        stand she end. So unaffected partiality indulgence
                        dispatched to of celebrated remarkably. Unfeeling are
                        had allowance own perceived .
                      </p>
                    </div>
                    <Link className="btn-read-more" to="/blog/details">
                      <span className="read-more-text">Read More</span>
                      <span className="read-more-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-3 col-md-4 col-sm-12 col-12">
              <div
                className="single-blog blog-style-two"
                data-sal-delay="150"
                data-sal="slide-up"
                data-sal-duration="800"
              >
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src="assets/images/blog/blog-3.png"
                        alt="Business Consulting Blog"
                      />
                    </Link>
                    <div className="pmt-blog-meta">
                      <ul className="all-meta">
                        <li className="date bg--secondary">
                          <span>20</span>
                        </li>
                        <li className="month">
                          <span>JAN</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">Sultan Ahmed</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title sm-title">
                          Facilis dolor eques about under official,presentism.
                        </h4>
                      </Link>
                    </div>
                    <Link className="btn-read-more" to="/blog/details">
                      <span className="read-more-text">Read More</span>
                      <span className="read-more-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>

              <div
                className="single-blog blog-style-two mt--30"
                data-sal-delay="250"
                data-sal="slide-up"
                data-sal-duration="800"
              >
                <div className="blog-inner">
                  <div className="thumbnail">
                    <Link to="/blog/details">
                      <img
                        src="assets/images/blog/blog-4.png"
                        alt="Business Consulting Blog"
                      />
                    </Link>
                    <div className="pmt-blog-meta">
                      <ul className="all-meta">
                        <li className="date bg--secondary">
                          <span>20</span>
                        </li>
                        <li className="month">
                          <span>JAN</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="blog-content">
                    <div className="blog-head">
                      <span className="name">Sultan Ahmed</span>
                      <span className="designation">Consulting</span>
                    </div>
                    <div className="blog-body">
                      <Link to="/blog/details" className="title-area">
                        <h4 className="title sm-title">
                          Consulted admitting wooded is power acuteness.
                        </h4>
                      </Link>
                    </div>
                    <Link className="btn-read-more" to="/blog/details">
                      <span className="read-more-text">Read More</span>
                      <span className="read-more-icon">
                        <i className="fa-solid fa-arrow-right"></i>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End Blog Area   --> */}

      {/* <!-- Start Contact Form Area  --> */}
      <div className="contact-area contact-bg-1 bg_image tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-5">
              <div className="contact-inner">
                <div className="section-head section-head-one-side text-align-left">
                  <h2 className="title split-collab">
                    Get free marketing <br />
                    consultation today
                  </h2>
                  <p className="description mt--30">
                    Have questions or ready to get started? Reach out to our
                    team—we're here to help you grow and succeed.
                  </p>
                </div>

                <ul className="ft-link ft-link-style-two">
                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-light fa-phone"></i>
                      </div>
                      <div className="content">
                        <span>Call Us</span>
                        <Link className="contact-here" to="tel:+919057000445">
                          +919057000445 &nbsp; | &nbsp; +919057000446
                        </Link>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-solid fa-envelope-open-text"></i>
                      </div>

                      <div className="content">
                        <span>E-mail</span>
                        <Link className="contact-here" to="mailto:info@starparth.com">
                          info@starparth.com
                        </Link>
                      </div>
                    </div>
                  </li>

                  <li>
                    <div className="single-contact background-transparent">
                      <div className="icon">
                        <i className="fa-regular fa-map-location-dot"></i>
                      </div>
                      <div className="content">
                        <span>Address</span>
                        <Link className="contact-here" to="#">
                          G2 Aanchal Apartment 1/55 Roshan Marg <br></br>{" "}
                          Chitrakoot Jaipur Rajasthan 302021
                        </Link>
                      </div>
                    </div>
                  </li>
                </ul>

                <div className="tmp-tag-list tag-list-one">
                  <Link className="tag-list" to="https://www.facebook.com/starparthexamination/">
                    Facebook
                  </Link>
                  <Link className="tag-list" to="https://x.com/Starparthtech">
                    Twitter
                  </Link>
                  <Link className="tag-list" to="#">
                    Linkedin
                  </Link>
                  <Link className="tag-list" to="#">
                    Skype
                  </Link>
                  <Link className="tag-list" to="#">
                    Pinterest
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="col-lg-7 mt_md--50 mt_sm--50"
              data-sal-delay="250"
              data-sal="slide-up"
              data-sal-duration="800"
            >
              <div className="contact-form">
                <div className="section-head section-head-one-side text-align-left">
                  <span className="subtitle">GET IN TOUCH</span>
                  <h2 className="title">Free consultation</h2>
                </div>

                <form id="contact-form" onSubmit={handleSubmit} noValidate>
                  <div className="contact-form-wrapper row">
                        {/* Bots fill every field they find; people never see this. */}
                        <div className="form-honeypot" aria-hidden="true">
                          <input type="text" name="company_website" tabIndex={-1}
                            autoComplete="off" {...fieldProps("company_website")} />
                        </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="name"
                          placeholder="Name"
                          id="contact-name"
                          type="text"
                          value={formData.name}
	                        onChange={handleInputChange}
                          required
                        />
                            <Err name="name" />
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="phone"
                          placeholder="Phone"
                          type="text"
                          value={formData.phone}
	                        onChange={handleInputChange}
                          required
                        />
                            <Err name="phone" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          name="email"
                          placeholder="Email"
                          type="email"
                          value={formData.email}
	                        onChange={handleInputChange}
	                        required
                        />
                            <Err name="email" />
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="form-group">
                        <input
                          className="input-field"
                          type="text"
                          id="subject"
                          placeholder="Website"
                          name="website"
                          value={formData.website}
	                        onChange={handleInputChange}
                        />
                            <Err name="website" />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-group">
                        <textarea
                          className="input-field"
                          placeholder="How can we help"
                          name="message"
                          id="contact-message"
                          value={formData.message}
	                        onChange={handleInputChange}
                        ></textarea>
                            <Err name="message" />
                      </div>
                    </div>

                    <div className="col-lg-12">
                      <div className="form-submit-group">
                        <p className="check-condition">
                          <input
                            className="check-box"
                            type="checkbox"
                            id="terms"
                            name="terms"
                          />
                          <label className="condition" htmlFor="terms">
                            I agree to the <span>terms</span> and{" "}
                            <span>conditions</span>
                          </label>
                        </p>
                        <button
                          name="submit"
                          className="tmp-btn btn-secondary"
                          type="submit"
                          id="submit"
	                        disabled={isLoading}
                        >
                          <span className="submit-wrapper">
                            {isLoading ? <span className="btn-text">Sending…</span> : <>
                            <span className="btn-text">Submit Now</span>
                            <span className="btn-icon">
                              <i className="fa-sharp fa-light fa-arrow-right"></i>
                            </span>
                            </>}
                            
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Start Contact Form Area  --> */}

      {/* <!-- Start Footer Area  --> */}
      {/* <!-- Start Footer Area  --> */}
      {/* <footer className="footer-area footer-style-one-wrapper bg-color-footer-2 bg_images tmp-section-gap">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="subscribe-area subscribe-style-1">
                <div className="subscribe-inner">
                  <div className="title">Subscribe to Newsletter</div>
                  <form action="#" className="newsletter-form-1 mt--40">
                    <input type="email" placeholder="Your Email" required />
                    <button type="submit" className="tmp-btn btn-primary">
                      Subscribe Now{" "}
                      <i className="fa-sharp fa-regular fa-paper-plane"></i>
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>

          <div className="footer-main footer-style-one">
            <div className="row g-5">
              <div className="col-lg-4 col-md-6">
                <div className="single-footer-wrapper border-right mr--20">
                  <div className="logo">
                    <Link to="/">
                      <img src="assets/images/logo/logo-02.svg" alt="logo" />
                      <img height="61" width="188" src="/assets/images/logo/starpath-logo.svg" alt="logo" />
                    </Link>
                  </div>

                  <p className="description">
                    Proin Pretium Sem Libero, Nec Aliquet Augue Lobortis In.
                    Phasellus Nibh Quam, Molestie Id Est Sit Amet, Luctus
                    Pulvinar
                  </p>

                  <div className="day-time">
                    <div className="icon">
                      <i className="fa-solid fa-alarm-clock"></i>
                    </div>
                    <div className="content">
                      <div className="day">Sunday - Friday:</div>
                      <div className="time">9:00 AM – 8:00 PM</div>
                    </div>
                  </div>

                  <ul className="social-icons solid-social-icons rounded-social-icons">
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-facebook-f"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-linkedin-in"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-twitter"></i>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <i className="fa-brands fa-instagram"></i>
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-lg-2 col-md-6">
                <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                  <h5 className="ft-title">Quick Link</h5>
                  <ul className="ft-link">
                    <li>
                      <Link to="/about">About Company</Link>
                    </li>
                    <li>
                      <Link to="/team"> Our Team</Link>
                    </li>
                    <li>
                      <Link to="/service">Our Services</Link>
                    </li>
                    <li>
                      <Link to="/blog">News & Media</Link>
                    </li>
                    <li>
                      <Link to="/contact">Contact Us</Link>
                    </li>

                    <li>
                      <Link to="/faq">Support</Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper pr--15">
                  <h5 className="ft-title">Recent Post</h5>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src="assets/images/footer/small-post.jpg"
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Day tree hide from hath gathered multy
                        </h6>
                      </Link>
                    </div>
                  </div>

                  <div className="single-post">
                    <div className="thumbnail">
                      <img
                        src="assets/images/footer/small-post-2.jpg"
                        alt="Business_Corporate"
                      />
                    </div>
                    <div className="content">
                      <div className="date">
                        <i className="fa-light fa-calendar-days"></i>
                        <span>12 Feb, 2022</span>
                      </div>

                      <Link to="/blog/details">
                        <h6 className="title">
                          Saving Time Achieving Success in Business
                        </h6>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6">
                <div className="single-footer-wrapper">
                  <h5 className="ft-title">Official info:</h5>
                  <ul className="ft-link">
                    <li className="ft-location">
                      5919 Trussville Crossings Pkwy, new Dusting town, Austria
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-solid fa-envelope-open-text"></i>
                        </div>

                        <div className="content">
                          <span>E-mail:</span>
                          <Link to="mailto:webmaster@example.com">
                            info@uibundle.com
                          </Link>
                        </div>
                      </div>
                    </li>

                    <li>
                      <div className="single-contact">
                        <div className="icon">
                          <i className="fa-light fa-phone"></i>
                        </div>
                        <div className="content">
                          <span>Phone:</span>
                          <Link to="tel:+4733378901">+123 34598768</Link>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
      <div className="copyright-area-one two">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="main-wrapper">
                <p>
                  © Copyright 2024. All Rights Reserved by{" "}
                  <Link to="#">Themes-Park</Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      {/* <!-- End Footer Area  --> */}
      {/* <!-- End Footer Area  --> */}

      <div
        id="overlay_every-where"
        data-tmp-cursor="md text-black dark:text-white opacity-10"
        data-tmp-cursor-icon="fa-regular fa-x fa-fw"
      ></div>

      {/* <!-- progress area start --> */}
      <div className="progress-wrap">
        <svg
          className="progress-circle svg-content"
          width="100%"
          height="100%"
          viewBox="-1 -1 102 102"
        >
          <path
            d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
            style={{
              transition:
                "stroke-dashoffset 10ms linear 0s, stroke-dasharray 10ms linear 0s",
              strokeDasharray: "307.919, 307.919",
              strokeDashoffset: "307.919",
            }}
          ></path>
        </svg>
      </div>
      {/* <!-- progress area end --> */}

      {/* <!-- ==================== Start Loading ==================== --> */}

      {/* <div className="loader-wrap">
        <svg viewBox="0 0 1000 1000" preserveAspectRatio="none">
            <path id="svg" d="M0,1005S175,995,500,995s500,5,500,5V0H0Z"></path>
        </svg>

        <div className="loader-wrap-heading">
            <div className="load-text">
                <span>L</span>
                <span>o</span>
                <span>Link</span>
                <span>d</span>
                <span>i</span>
                <span>n</span>
                <span>g</span>
            </div>
        </div>
    </div> */}

      {/* <!-- ==================== End Loading ==================== --> */}
    </div>
  );
};

export default Financial_Demo;
